<template>
  <a-form-item
    :label="item.fieldname"
  >
    <a-select
      v-decorator="[item.fieldkey, { rules: [{ required: true, message: `${enterPlaceholder}${item.fieldname }` }],initialValue: item.defaultValue}]"
      :placeholder="selectPlaceholder"
      @change="getValue"
    >
      <a-select-option
        v-for="(item2, index) in item.options"
        :key="index"
        :label="`${item2.name}`"
        :value="item2.id"
      >
        {{ item2.name }}
      </a-select-option>
    </a-select>
  </a-form-item>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    enterPlaceholder () {
      return this.$t('message["751"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    }
  },
  methods: {
    getValue (val) {
      // this.item.defaultValue = val
      this.$set(this.item, 'defaultValue', val)
    }
  }
}
</script>
